
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { CheckCircle2 } from "lucide-react";

const PaymentSuccess = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md p-6 text-center space-y-4">
        <div className="flex justify-center">
          <CheckCircle2 className="h-16 w-16 text-green-500" />
        </div>
        <h1 className="text-2xl font-semibold text-gray-900">Payment Successful!</h1>
        <p className="text-gray-600">
          Your payment has been processed successfully. You can now close this window.
        </p>
        <div className="pt-4">
          <Button
            onClick={() => window.close()}
            className="w-full"
          >
            Close Window
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
